// ── Severity colors ──────────────────────────────────────────────────────────
export const SEV_COLOR = { 0: '#34c95f', 1: '#f5a623', 2: '#e84040' } as const
export const SEV_LABEL = { 0: 'healthy', 1: 'warning', 2: 'critical' } as const

// ── Theme tokens (with CSS-var fallbacks) ────────────────────────────────────
export const col = {
  bg0: 'var(--bg-0, #0d0d14)',
  bg1: 'var(--bg-1, #12121c)',
  bg2: 'var(--bg-2, #16162a)',
  bd:  'var(--bd-0, rgba(255,255,255,0.07))',
  t1:  'var(--t-1, #e0e0f0)',
  t2:  'var(--t-2, #7070a0)',
} as const

export const card = {
  background: col.bg2,
  border: `0.5px solid ${col.bd}`,
  borderRadius: 8,
} as const

// ── Country-fill palette (used by useCountryStyles) ──────────────────────────
// Critical = red, warning = orange, healthy = green, inactive = grey.
export const COUNTRY_FILL = {
    active: {
      // Tier convention: 0 = critical, 1 = warning, 2 = healthy (see utils/severity.ts).
      fill: (sev: 0 | 1 | 2) =>
        sev === 0 ? 'rgba(232,64,64,0.22)'   // critical
        : sev === 1 ? 'rgba(245,166,35,0.18)' // warning
        : 'rgba(52,201,95,0.14)',             // healthy
      stroke: (sev: 0 | 1 | 2) =>
        sev === 0 ? 'rgba(232,64,64,0.55)'
        : sev === 1 ? 'rgba(245,166,35,0.50)'
        : 'rgba(52,201,95,0.45)',
    },
    inactive: {
      fill:   'rgba(255,255,255,0.06)',
      stroke: 'rgba(200,210,230,0.22)',
    },
  } as const

// ── Static SVG CSS (does not depend on props/state) ──────────────────────────
export const BASE_MAP_CSS = `
  .world-land path {
    fill: ${COUNTRY_FILL.inactive.fill};
    fill-opacity: 1;
    stroke: ${COUNTRY_FILL.inactive.stroke};
    stroke-width: 0.7;
    transition: fill 160ms ease, fill-opacity 160ms ease, stroke 160ms ease;
  }

  @keyframes wsPulse {
    0%   { filter: drop-shadow(0 0 0 rgba(0,0,0,0)); transform: scale(1); }
    35%  { filter: drop-shadow(0 0 10px rgba(120,160,255,0.18)); transform: scale(1.025); }
    100% { filter: drop-shadow(0 0 0 rgba(0,0,0,0)); transform: scale(1); }
  }

  .ws-pulse {
    animation: wsPulse 420ms ease-out;
    transform-origin: center;
  }
`

export const STREAM_PULSE_CSS = `
  @keyframes svgPulse {
    0%   { r: 12; opacity: 0.9; }
    70%  { r: 26; opacity: 0; }
    100% { r: 26; opacity: 0; }
  }
  .stream-pulse {
    animation: svgPulse 1.8s ease-out infinite;
    transform-box: fill-box;
    transform-origin: center;
  }
`
